import type {
  ActionState,
  GenerationControlResponse,
  PublicationPauseResponse,
  PublicationResumeResponse,
  QueueControlResult,
} from "./useDashboardActions";

export function buildSnackbarMessage(actionState: ActionState<QueueControlResult>): string {
  let snackbarMessage: string;
  if (actionState.kind === "success") {
    const queueState = actionState.result;
    snackbarMessage = queueState.queueStatus === "paused"
      ? formatDrainedMessage(queueState)
      : formatRequeuedMessage(queueState);
  } else {
    if (actionState.kind === "error") {
      snackbarMessage = actionState.message;
    } else {
      snackbarMessage = "";
    }
  }
  return snackbarMessage;
}

function formatDrainedMessage(result: GenerationControlResponse | PublicationPauseResponse): string {
  const sitewide = "drainedSitewideCount" in result ? `, sitewide ${result.drainedSitewideCount}` : "";
  return `Очередь приостановлена. Удалено: статьи ${result.drainedArticleCount}, homepage ${result.drainedHomepageCount}${sitewide}`;
}

function formatRequeuedMessage(result: GenerationControlResponse | PublicationResumeResponse): string {
  const sitewide = "requeuedSitewideCount" in result ? `, sitewide ${result.requeuedSitewideCount}` : "";
  return `Очередь возобновлена. Восстановлено: статьи ${result.requeuedArticleCount}, homepage ${result.requeuedHomepageCount}${sitewide}`;
}
